"use strict";
exports.__esModule = true;
exports.VALID_TOKENS = exports.OPERATOR_PRECEDENCE = void 0;
var types_1 = require("../types");
exports.OPERATOR_PRECEDENCE = {
    NOT: 0,
    XOR: 1,
    AND: 2,
    OR: 3
};
exports.VALID_TOKENS = {
    identifierOnly: [
        { name: types_1.Tokens.IDENTIFIER },
        {
            name: types_1.Tokens.STRUCTURAL_CHARACTER,
            value: types_1.StructuralCharacters.OPEN_PARENTHESIS
        },
    ],
    identifierOrNot: [
        { name: types_1.Tokens.IDENTIFIER },
        {
            name: types_1.Tokens.STRUCTURAL_CHARACTER,
            value: types_1.StructuralCharacters.OPEN_PARENTHESIS
        },
        { name: types_1.Tokens.OPERATOR, value: types_1.Operators.NOT },
    ],
    binaryOperator: [
        { name: types_1.Tokens.OPERATOR, value: types_1.Operators.AND },
        { name: types_1.Tokens.OPERATOR, value: types_1.Operators.OR },
        { name: types_1.Tokens.OPERATOR, value: types_1.Operators.XOR },
    ],
    binaryOperatorOrClose: [
        { name: types_1.Tokens.OPERATOR, value: types_1.Operators.AND },
        { name: types_1.Tokens.OPERATOR, value: types_1.Operators.OR },
        { name: types_1.Tokens.OPERATOR, value: types_1.Operators.XOR },
        {
            name: types_1.Tokens.STRUCTURAL_CHARACTER,
            value: types_1.StructuralCharacters.CLOSE_PARENTHESIS
        },
    ]
};
